import {
  GET_QUOTES,
  GET_QUOTES_FAIL,
  GET_QUOTES_SUCCESS,
  ADD_NEW_QUOTE,
  ADD_QUOTE_SUCCESS,
  ADD_QUOTE_FAIL,
  UPDATE_QUOTE,
  UPDATE_QUOTE_SUCCESS,
  UPDATE_QUOTE_FAIL,
  DELETE_QUOTE,
  DELETE_QUOTE_SUCCESS,
  DELETE_QUOTE_FAIL,
  GET_QUOTE_DETAIL,
} from "./actionTypes"

export const getQuotes = page => ({
  type: GET_QUOTES,
  payload: page,

})

export const getQuotesSuccess = quotes => ({
  type: GET_QUOTES_SUCCESS,
  payload: quotes,
})

export const getQuotesFail = error => ({
  type: GET_QUOTES_FAIL,
  payload: error,
})

export const addNewQuote = quote => ({
  type: ADD_NEW_QUOTE,
  payload: quote,
})

export const addQuoteSuccess = quote => ({
  type: ADD_QUOTE_SUCCESS,
  payload: quote,
})

export const addQuoteFail = error => ({
  type: ADD_QUOTE_FAIL,
  payload: error,
})

export const updateQuote = quote => ({
  type: UPDATE_QUOTE,
  payload: quote,
})

export const updateQuoteSuccess = quote => ({
  type: UPDATE_QUOTE_SUCCESS,
  payload: quote,
})

export const updateQuoteFail = error => ({
  type: UPDATE_QUOTE_FAIL,
  payload: error,
})

export const deleteQuote = quote => ({
  type: DELETE_QUOTE,
  payload: quote,
})

export const deleteQuoteSuccess = quote => ({
  type: DELETE_QUOTE_SUCCESS,
  payload: quote,
})

export const deleteQuoteFail = error => ({
  type: DELETE_QUOTE_FAIL,
  payload: error,
})

export const getQuoteDetails = quote => ({
  type: GET_QUOTE_DETAIL,
  payload: quote,
})

export const getQuoteDetailFail = error => ({
  type: GET_QUOTE_DETAIL_FAIL,
  payload: error,
})


export const getQuoteDetailSuccess = quote => ({
  type: GET_QUOTE_DETAIL_SUCCESS,
  payload: quote,
})


